import React from 'react';
import moment from 'moment';
import * as bootstrap from 'bootstrap';
import { ArrowDownCircle32, CheckCircleFill, Info } from '../../components/tools/Icons';
import { LoadingPage } from '../../components/tools/Others';
import { convertSimCardActivationProcessAuditAudit, convertSimCardActivationProcessStatus } from '../../helpers/converters';
import { UneditableTextInput } from '../../components/tools/BootstrapControls';
import uiHelpers from '../../helpers/uiHelpers';
import * as apiCaller from '../../helpers/apiCaller'
import serviceUrls from '../../constants/serviceUrls';

export default class SimActivationProcess  extends React.Component {

    confirmationModalId = "model_confirm_" + (new Date()).getTime();
    confirmationModal;

    payloadModalElementId = "model_payload_" + (new Date()).getTime();
    payloadModal;

    constructor(props) {
        super(props);

        this.state = {
            initialising:true,
            loading : false,
            process : props.process,
            audits : props.audits,
            confirmationAction : null
        };
    }

    async componentDidMount() {
        this.confirmationModal = new bootstrap.Modal(document.getElementById(this.confirmationModalId));
        this.payloadModal = new bootstrap.Modal(document.getElementById(this.payloadModalElementId));

        if(this.props.processId)
            await apiCaller.post(serviceUrls.simManagement.getProcessDetails,{id:this.props.processId}).then(this.wholePageDataBind)
        else if(this.props.meterCommissionId)
            await apiCaller.post(serviceUrls.simManagement.getCurrentProcessDetialsForMeterCommission,{meterCommissionId:this.props.meterCommissionId}).then(this.wholePageDataBind)
    }

    onMarkAsCompletedBtnClicked = () => {this.setState({confirmationAction : 'MARK_AS_CONFIRM'},()=>{this.confirmationModal.show();})}
    onDiscardBtnClicked = () => {this.setState({confirmationAction : 'DISCARD_AND_NEW'},()=>{this.confirmationModal.show();})}
    onRetryActivateBtnClicked = () => {this.setState({confirmationAction : 'RETRY_ACTIVATION'},()=>{this.confirmationModal.show();})}
    onRetryUpdateToDasBtnClicked = () => {this.setState({confirmationAction : 'RETRY_UPDATE_TO_DAS'},()=>{this.confirmationModal.show();})}
    onRetryIpReterievalBtnClicked = () => {this.setState({confirmationAction : 'RETRY_IP_RETRIEVAL'},()=>{this.confirmationModal.show();})}
   
    onApiPayloadBtnClick = (audit) => {
        this.setState({payloadAudit:audit},()=>this.payloadModal.show());
    }

    wholePageDataBind = (data) =>{
        this.setState({
            process:data.process,
            audits:data.audits,
            loading:false,
            initialising:false
        },()=>{
            if(this.props.onHasErrFlagChanged) {
                this.props.onHasErrFlagChanged(data.process.status=='IN_PROGRESS' && data.process.hasError)
            }
        })
    }


    onComfirmationBtnClicked = async () => {
        let url = "";
        let payload = null;
        switch(this.state.confirmationAction) {
            case 'MARK_AS_CONFIRM' : url = serviceUrls.simManagement.activationProcessMarkAsCompleted;payload={id:this.state.process.id};break;
            case 'RETRY_ACTIVATION' : url = serviceUrls.simManagement.activationProcessRetrySimActivation;payload={id:this.state.process.id};break;
            case 'RETRY_UPDATE_TO_DAS' : url = serviceUrls.simManagement.activationProcessRetryUpdateToDas;payload={id:this.state.process.id};break;
            case 'RETRY_IP_RETRIEVAL' : url = serviceUrls.simManagement.activationProcessRetryIpReterieval;payload={id:this.state.process.id};break;
            case 'DISCARD_AND_NEW' : url = serviceUrls.simManagement.restartActivationProcessForMeterCommission;payload={meterCommissionId:this.state.process.meterCommissionId};break;
            default : return;
        }

        uiHelpers.showProgressOnTop('Please wait...');
        this.setState({loading : true})
        await apiCaller.post(url,payload)
        .then((data) => {
            this.wholePageDataBind(data);
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
            this.confirmationModal.hide();
        })
        ;
    }

    

    renderConfirmationModalTitle = () => {return "Please confirm the following action."}

    renderConfirmationModelContent =() => {
        const cp = this.state.process;
        switch(this.state.confirmationAction) {
            case 'MARK_AS_CONFIRM' : return <>
                <p className='text-primary'><b>Please confirm that you would like to mark the SIM Card activation process as completed.</b></p>
                <div>
                    Note that this means that the SIM Card activation has been completed outside the DQP Portal.
                </div>
            </>;
            case 'RETRY_ACTIVATION' : return <>
                <b className='text-primary'>Please confirm that you would like to re-trigger the system to activate SIM card in Telstra.</b>
            </>;
            case 'RETRY_UPDATE_TO_DAS' : return <>
                <b className='text-primary'>Please confirm that you would like to re-trigger the system to update the SIM card details to DAS.</b>
            </>;
            case 'RETRY_IP_RETRIEVAL' : return <>
                <b className='text-primary'>Please confirm that you would like to re-trigger the system to get IP address from Telstra.</b>
            </>;
            case 'DISCARD_AND_NEW' : return <>
                <p><b className='text-primary'>Please confirm that you would like to discard this SIM Activation process.</b></p>
                <p>Please note that the system will start a new SIM Activation Process based on the current selected Iccid in the Meter Compliance Process.</p>
                {this.props.selectedIccidInMC && cp && cp.iccid && <>
                    <p>
                    Discarding SIM Activation Process for :<b>{cp.iccid}</b>
                    </p>
                    <p>
                    Strting SIM Activation Process for :<b>{this.props.selectedIccidInMC}</b>
                    </p>
                </>}
            </>;
            default: return null;
        }
    }

    renderPopups() {
        
        return <>
            <div class="modal fade" id={this.confirmationModalId} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{this.renderConfirmationModalTitle()}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"  disabled={this.state.loading} aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                           {this.renderConfirmationModelContent()}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" disabled={this.state.loading} onClick={this.onComfirmationBtnClicked}>Confirm</button>
                            <button type="button" class="btn btn-secondary" disabled={this.state.loading} data-bs-dismiss="modal">Cancel</button>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="modal fade" id={this.payloadModalElementId} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Payloads of API call history</h5>
                        </div>
                    <div class="modal-body">
                        {this.state.payloadAudit && <>
                            <div class="mb-3">
                                <label className="form-label">Request Payload</label>
                                <textarea className="form-control bg-white" readOnly={true} rows="5" value={this.state.payloadAudit.externalApiRequestPayload} />
                            </div>
                            <div class="mb-3">
                                <label className="form-label">Response Code</label>
                                <UneditableTextInput value={this.state.payloadAudit.externalApiResponseCode} />
                            </div>
                            <label className="form-label">Response Payload</label>
                            <textarea className="form-control bg-white" readOnly={true} rows="5" value={this.state.payloadAudit.externalApiResponseContent} />
                        </>}
                    </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" disabled={this.state.loading} data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    render() {
        return <>
            {this.renderPopups()}
            {this.renderMainContent()}
        </>
    }

    renderMainContent() {
        if(this.state.initialising) return <LoadingPage />

        const cp = this.state.process;
        const audits = this.state.audits;
        let errorTextClass = "text-danger"
        let errorBorderClass = "border-danger"
        let errorBadgeClass = "badge bg-danger"
        if(cp.status != 'IN_PROGRESS') {
            errorTextClass = "text-secondary"
            errorBorderClass = "opacity-75"
            errorBadgeClass = "badge bg-danger opacity-50"
        }
        return <>
            <div className='row mb-3'>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Process ID</>}
                        value={cp.id}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>SIM ICCID</>}
                        value={cp.iccid}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Status</>}
                        value={convertSimCardActivationProcessStatus(cp.status)}
                    />
                </div>
            </div>

            {this.props.displayRelatedForms && <div className='row mb-3'>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>MCP Form ID</>}
                        value={<>
                            {cp.meterCommissionId}
                            <a href={`/#/compliance-process/${cp.meterCommissionId}/lid-registration`} target='_blank' className='ps-2 fs-80 float-end'>Open</a>
                        </>}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Meter ID</>}
                        value={<>
                            {cp.meterId}
                            <a href={`/#/admin/meter/${cp.meterId}`} target='_blank' className='ps-2 fs-80 float-end'>Open</a>
                        </>}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>DAS workspace ID</>}
                        value={cp.dasWorkspaceId}
                    />
                </div>
                <div className='col-md-3 mb-3'>
                    <UneditableTextInput
                        label={<>Source ID</>}
                        value={cp.dasSourceId}
                    />
                </div>
            </div>}

            {cp.status == 'IN_PROGRESS' && this.props.selectedIccidInMC && this.props.selectedIccidInMC != cp.iccid && <div className='alert alert-warning'>
                <p>
                    The system has detected that the SIM ICCID selected in the Meter Compliance Process differs from the one used in this SIM Activation.
                </p>
                <p>
                    SIM ICCID in Meter Compliance Process: <b>{this.props.selectedIccidInMC}</b>
                </p>
                <p>
                    SIM ICCID in this activation: <b>{cp.iccid}</b>
                </p>
                You may use the "<b>Discard and Start New</b>" function to initiate a new SIM Activation process based on the current SIM ICCID selection in the Meter Compliance Process.
                
            </div>}
            
            <div className='card mb-3'>
                <div className='card-body'>
                    <div className='text-center' style={{margin:"0 auto","max-width":"450px"}}>

                        <div className="card mb-3 border-success">
                            <div className='card-body text-success'>
                                Triggered at <b>{moment((new Date(cp.createdDate))).format('DD/MM/YYYY h:mm:ss a')}</b>
                            </div>
                        </div>

                        <div className='mb-3'>
                            <ArrowDownCircle32 />
                        </div>

                        {cp.simActivated == true && <div className="card mb-3 border-success">
                            <div className='card-body text-success'>
                                <div><span className="badge bg-success">Completed</span></div>
                                Activate SIM card in Telstra
                            </div>
                        </div>}

                        {cp.simActivated == false && cp.hasError && <div className={"card mb-3 " + errorBorderClass}>
                            <div className='card-body'>
                                <p>
                                    <div className={errorBadgeClass}>Failed - &nbsp;
                                        {cp.errorCode == "SIM_JASPER_STATUS_NOT_VALID" && "Status not valid"}
                                        {cp.errorCode == "GET_SIM_DETAILS_ERR" && "Get SIM details error"}
                                        {cp.errorCode == "SIM_ACTIVATION_ERR" && "Activation error"}
                                    </div> 
                                </p>
                                <p className={errorTextClass}>
                                    Activate SIM card in Telstra
                                </p>
                                {cp.status=='IN_PROGRESS'&& !this.props.disableBtns && <div>
                                    <button className='btn btn-primary' onClick={this.onRetryActivateBtnClicked}>Retry</button>
                                </div>}
                                {cp.status != 'IN_PROGRESS' && <span className="badge bg-secondary">Error ignored</span>}
                            </div>
                            
                        </div>}

                        <div className='mb-3'>
                            <ArrowDownCircle32 />
                        </div>

                        {cp.fixIpRetrieved == false && cp.simActivated == true && cp.hasError == false && <div className="card mb-3 border-info ">
                            <div className='card-body text-info '>
                                <div><span className="badge bg-info ">
                                    <div class="spinner-grow spinner-grow-sm" role="status"></div> Ongoing...
                                    </span></div>
                                Retrieve IP Address of SIM from Telstra
                            </div>
                        </div>}

                        {cp.fixIpRetrieved == false && cp.simActivated == true && cp.hasError && <div className={"card mb-3 " + errorBorderClass}>
                            <div className='card-body'>
                                <p>
                                    <div className={errorBadgeClass}>Failed</div> 
                                </p>
                                <p className={errorTextClass}>
                                    Retrieve IP Address of SIM from Telstra
                                </p>

                                {cp.status=='IN_PROGRESS'&& !this.props.disableBtns && <div>
                                    <button className='btn btn-primary' onClick={this.onRetryIpReterievalBtnClicked}>Retry</button>
                                </div>}
                                {cp.status != 'IN_PROGRESS' && <span className="badge bg-secondary">Error ignored</span>}
                            </div>
                        </div>}

                        {cp.fixIpRetrieved == false && cp.simActivated == false && <div className="card mb-3 ">
                            <div className='card-body opacity-75'>
                            <div>Retrieve IP Address of SIM from Telstra</div>
                            {cp.status != 'IN_PROGRESS' && <span className="badge bg-secondary mt-2">Skipped</span>}
                            </div>
                        </div>}

                        {cp.fixIpRetrieved == true && <div className="card mb-3 border-success">
                            <div className='card-body text-success'>
                                <div><span className="badge bg-success">Completed</span></div>
                                Retrieve IP Address of SIM from Telstra
                            </div>
                        </div>}

                        <div className='mb-3'>
                            <ArrowDownCircle32 />
                        </div>

                        {cp.ipUpdatedToDas == false && cp.fixIpRetrieved == true && cp.hasError && <div className={"card mb-3 " + errorBorderClass}>
                            <div className='card-body'>
                                <p>
                                    <div className={errorBadgeClass}>Failed</div> 
                                </p>
                                <p className={errorTextClass}>
                                    Update SIM card details to DAS
                                </p>

                                {cp.status=='IN_PROGRESS'&& !this.props.disableBtns && <div>
                                    <button className='btn btn-primary' onClick={this.onRetryUpdateToDasBtnClicked}>Retry</button>
                                </div>}
                                {cp.status != 'IN_PROGRESS' && <span className="badge bg-secondary">Error ignored</span>}
                            </div>
                        </div>}

                        {cp.ipUpdatedToDas ==  false && cp.fixIpRetrieved == false && <div className="card mb-3 ">
                            <div className='card-body opacity-75'>
                                <div>Update SIM card details to DAS</div>
                                {cp.status != 'IN_PROGRESS' && <span className="badge bg-secondary mt-2">Skipped</span>}
                            </div>
                        </div>}

                        {cp.ipUpdatedToDas == true && <div className="card mb-3 border-success">
                            <div className='card-body text-success'>
                                <div><span className="badge bg-success">Completed</span></div>
                                Update SIM card details to DAS
                            </div>
                        </div>}

                        {cp.status=="COMPLETED" && <>
                            <div className='mb-3'>
                                <ArrowDownCircle32 />
                            </div>
                            <div className="card mb-3 border-success">
                                <div className='card-body text-success'>
                                    <div><CheckCircleFill /></div>
                                    <div>Completed at <b>{moment((new Date(cp.completionDate))).format('DD/MM/YYYY h:mm:ss a')}</b></div>
                                    {cp.ignoreErrorsForCompletion && <span className="badge bg-success mt-2">Manually completed</span>}
                                </div>
                            </div>
                        </>}

                        {cp.status=="DISCARDED" && <>
                            <div className='mb-3'>
                                <ArrowDownCircle32 />
                            </div>
                            <div className="card mb-3 border-secondary">
                                <div className='card-body'>
                                    <div>Discarded at <b>{moment((new Date(cp.discardedDate))).format('DD/MM/YYYY h:mm:ss a')}</b></div>
                                </div>
                            </div>
                        </>}

                        {cp.status =='IN_PROGRESS' && cp.hasError && this.props.disableBtns && <div className='alert alert-primary mt-5'>
                            Please note that this process is currently in progress but has encountered an <b className='text-danger'>error</b>. 
                            To re-trigger the failed step, please navigate to the 
                            &nbsp;<a href={`/#/compliance-process/${cp.meterCommissionId}/lid-registration`} target='_blank'>Meter Compliance Process</a>&nbsp;
                            page and go to <b>LID Registration</b> stage.
                        </div>}

                        {cp.status =='IN_PROGRESS' && cp.hasError && !this.props.disableBtns && <div className='mt-5'>
                            <button className='btn btn-primary me-2' onClick={this.onMarkAsCompletedBtnClicked}>Mark as Completed</button>
                            {this.props.selectedIccidInMC && this.props.selectedIccidInMC != cp.iccid && <button className='btn btn-primary' onClick={this.onDiscardBtnClicked}>Discard and Start New</button>}
                        </div>}

                    </div>
                </div>
            </div>


            <div class="table-responsive-xxl">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" style={{width:"200px"}}>Date &amp; Time</th>
                            <th scope="col" style={{width:"200px"}}>Action</th>
                            <th scope="col" style={{width:"180px"}}>User</th>
                            <th scope="col">Comments / Other Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {audits.map(a=>{
                            return <tr>
                                <td>{moment((new Date(a.auditDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td>{convertSimCardActivationProcessAuditAudit(a.auditAction)} {!a.actionSucceeded && <i className='text-danger fs-80'>(Action Failed)</i>}</td>
                                <td>{a.auditUser?<>{a.auditUser.firstname} {a.auditUser.lastname}</>:<i className='text-muted'>System</i>}</td>
                                <td>
                                    {a.comments}
                                    {a.externalApiResponseCode !=null && <button onClick={()=>this.onApiPayloadBtnClick(a)} className='btn btn-outline-secondary btn-sm float-end mx-2'><Info /></button>}
                                </td>

                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

            
        </>
    }
}